<template>
  <div>
    <SectionContainer id="window">
      <SectionFrame
        :title="'支援窓口・コーディネーター体制'"
        :description="'織物・繊維産地に携わるコーディネーター陣が伴走型の相談支援を実施します。\nまずは、一度お気軽にお問い合わせください。'">
        <Bg :bgcolor="'gray'" :radius="28">
          <div :class="s.contact_wrap">
            <div :class="s.contact_label">選べる相談・お問い合わせ方法</div>
            <ul :class="s.contact">
              <li v-for="(ct, i) in contacts" :key="i">
                <div :class="s.label">{{ ct.label }}</div>
                <div v-html="ct.description" :class="s.description" class="n2br"/>
                <div v-if="ct.tel" :class="s.tel">{{ ct.tel }}</div>
                <FlexList :align="'center'" :class="s.btns" v-if="ct.btns">
                  <li v-for="(btn, i) in ct.btns" :key="i">
                    <basic-btn
                      :tag="'a'"
                      :link="btn.link"
                      :size="'sm'"
                      :width="'fit-content'">{{ btn.label }}</basic-btn>
                  </li>
                </FlexList>
                <div v-html="ct.other" v-if="ct.other" :class="s.other" class="n2br"/>
              </li>
            </ul>
          </div>
        </Bg>
      </SectionFrame>
    </SectionContainer>

    <SectionContainer>
      <SectionFrame
        :title="'コーディネーター（窓口・チーフ）'"
        :maxWidth="1040">
        <FlexList
          :spaceX="40"
          :smSpaceX="32"
          :spaceY="48"
          :count="4"
          :smCount="1"
          :wrap="true"
          :align="'center'">
          <li v-for="cordinator of filteredCordinators(1)" :key="cordinator.id">
            <Cordinator :cordinator="cordinator"/>
          </li>
        </FlexList>
      </SectionFrame>
    </SectionContainer>

    <SectionContainer>
      <SectionFrame
        :title="'移住コーディネーター（地域）'"
        :maxWidth="1040">
        <FlexList
          :align="'center'"
          :wrap="true"
          :count="4"
          :spaceX="40"
          :smSpaceX="32"
          :spaceY="48"
          :smCount="1">
          <li v-for="cordinator of filteredCordinators(2)" :key="cordinator.id">
            <Cordinator :cordinator="cordinator"/>
          </li>
        </FlexList>
      </SectionFrame>
    </SectionContainer>

    <SectionContainer id="support">
      <SectionFrame
        :title="'支援制度'"
        :description="'あなたの産地との関わり（就労・開業）や移住・定住を応援する支援メニューを用意しています。\n※むすびすむ桐生（別サイト）へ遷移します。'">
        <SimpleList :hasLine="false" :margin="32">
          <li :style="{ textAlign: 'center' }"><basic-btn :link="'https://kiryu-iju.jp/kaigyou/#support'" :tag="'a'" :openOtherTab="true">就労・開業関連</basic-btn></li>
          <li :style="{ textAlign: 'center' }"><basic-btn :link="'https://kiryu-iju.jp/shien/#support'" :tag="'a'" :openOtherTab="true">移住・定住関連</basic-btn></li>
          <!-- <BgListItem
            v-for="item in adjustCards(card.cards, 'supports')"
            :key="item"
            :bgcolor="'gray'">
              <ContentListFrame :item="item" />
          </BgListItem> -->
        </SimpleList>
      </SectionFrame>
    </SectionContainer>

    <spacer :y="20" :smY="15"/>
    <Interview
      id="interview"
      :category="categoryId" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  Spacer,
  SectionFrame,
  BasicBtn,
  // ContentListFrame,
  Bg,
  Cordinator,
  SimpleList,
  SectionContainer,
  FlexList,
  Interview,
  // BgListItem,
} from '@/components/parts';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'support-living',
  components: {
    Spacer,
    // BgListItem,
    SectionFrame,
    BasicBtn,
    // ContentListFrame,
    Bg,
    Cordinator,
    SimpleList,
    SectionContainer,
    FlexList,
    Interview,
  },
  mixins: [cf],
  data() {
    return {
      card: {
        loading: true,
        notFound: false,
        cards: [],
      },
      contacts: [
        {
          label: '①お問い合わせフォーム（WEB）',
          description: '以下の「むすびすむ桐生」専用フォームからお問い合わせください。\n内容を確認し、窓口の移住コーディネーターから返信させていただきます。',
          btns: [
            {
              label: 'お問い合わせフォーム',
              link: '/contact',
            },
          ],
        },
        {
          label: '②専用電話',
          description: '以下の「むすびすむ桐生」専用番号までお電話ください。\nコーディネーターが相談対応や外出時など、電話に出られない場合には、お手数ですがご伝言を残していただけると助かります。',
          tel: '050-3529-6573',
          other: '平日・土日祝 10:00〜17:00\n休業日：年末年始',
        },
        {
          label: '③直接窓口へ',
          description: '以下の窓口へ直接お越しください。\n※事前にご連絡をいただけますと、よりスムーズな対応ができます。',
          other: '桐生市移住支援フロント「むすびすむ桐生」\n〒376-0031\n群馬県桐生市本町５丁目51番地東武桐生ビル１階cocotomo内\n平日・土日祝 10:00〜17:00休業日：年末年始\n<iframe src="//www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3210.9418613236458!2d139.3390005!3d36.410601899999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601ee246b92c0dab%3A0x6e0df46f281ef5!2z44Kz44Ov44O844Kt44Oz44Kw44O744Kz44Of44Ol44OL44OG44Kj44K544Oa44O844K544CMQ09DT1RPTU_jgI0!5e0!3m2!1sja!2sjp!4v1690767361195!5m2!1sja!2sjp" height="200" style="border: 2px solid rgba(0, 0, 0, 0.32); border-radius: 28px; margin-top: 32px; max-width: 400px; width: 100%;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
        },
      ],
    };
  },
  created() {
    this.getCards();
  },
  computed: {
    ...mapState(['helper']),
    cordinators() {
      return this.helper.master?.cordinator;
    },
    type() {
      return 'tex-shien';
    },
    categoryId() {
      return this.helper?.categories?.find((d) => d.name === this.type)?.id || null;
    },
  },
  methods: {
    filteredCordinators(type) {
      if (!this.cordinators) return [];
      return this.cordinators.filter((c) => c.type === type);
    },
    getCards() {
      const params = {
        flags: [1],
        type: 'tex-shien',
        orderBy: 'order',
        order: 'asc',
      };

      this.axios({
        method: 'GET',
        url: '/v1/card/get/list',
        params,
      })
        .then((response) => {
          this.card.cards = response.data.cards.data;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          console.log(error);
          this.card.notFound = true;
        })
        .finally(() => {
          this.card.loading = false;
        });
    },

    adjustedLink(str) {
      try {
        return JSON.parse(str);
      } catch {
        return [];
      }
    },
  },
};
</script>

<style lang="scss" module="s">
.steps {
  position: relative;
  padding: 32px 80px;
  background-color: #ffffff;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.15);
  border-radius: 28px;
  overflow: hidden;
  .step {
    background: linear-gradient(134deg, #61C0B0 0%, #ADCCC7 100%, #59B2A4 100%);
    color: #ffffff;
    font-weight: 700;
    position: absolute;
    width: 124px;
    height: 124px;
    top: -53px;
    left: -45px;
    border-radius: 50%;
    font-size: 28px;
    span {
      display: block;
      position: absolute;
      top: 62px;
      left: 62px;
    }
  }
  .title {
    font-size: 18px;
    font-weight: 700;
  }
  .description {
    margin-top: 14px;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .checks {
    &_label {
      margin-top: 1em;
    }
    // display: flex;
    flex-wrap: wrap;
    > li {
      padding-left: 20px;
      position: relative;
      margin-right: 16px;
      &::before, &::after {
        content: '';
        position: absolute;
      }
      &::before {
        width: 16px;
        height: 16px;
        top: 50%; left: 0;
        transform: translate(0, -42%);
        background-color: #cccccc;
        border-radius: 4px;
      }
      &::after {
        width: 14px;
        height: 7px;
        top: 50%; left: 0;
        transform: translate(3px, -65%) rotate(-35deg);
        border-left: 2px solid #ffffff;
        border-bottom: 2px solid #ffffff;
        box-shadow: rgba(0, 0, 0, 0.15) -2px 2px 2px;
      }
    }
  }
  .btns {
    margin-top: 16px;
  }
}

.contact {
  &_wrap {
    padding: 40px;
  }
  &_label {
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 32px;
  }

  font-size: 12px;
  text-align: center;

  > li {
    text-align: center;
    &:not(:first-child) {
      margin-top: 32px;
    }
  }
  .label {
    font-size: 16px;
    font-weight: 700;
  }
  .description {
    margin-top: 12px;
  }
  .tel {
    margin-top: 12px;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 8px;
  }
  .other {
    margin-top: 12px;
  }

  .btns {
    margin-top: 12px;
  }
}

@include smView {
  .steps {
    padding: 40px;
    .step {
      width: 69px;
      height: 69px;
      top: -24px;
      left: -24px;
      span {
        top: 30px;
        left: 30px;
        font-size: 20px;
      }
    }
    .title {
      font-size: 16px;
    }
    .description {
      font-size: 12px;
    }
    .checks {
      font-size: 12px;
      &_label {
        font-size: 12px;
      }
    }
  }
}
</style>
